<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-6 text-center">
        <div class="service-box mt-5 mx-auto">
          <mat-icon>browse_gallery</mat-icon>
          <h1>Palpites</h1>
          <p>Aceitos até o início de cada partida. Você pode trocar seu palpite sempre que mudar de ideia</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 text-center">
        <div class="service-box mt-5 mx-auto">
          <mat-icon>assured_workload</mat-icon>
          <h1>Auditável</h1>
          <p>
            Os palpites de todos os participantes são armazenados em <em>blockchain</em> no início de cada partida.
            Outro método é o envio de um e-mail contendo os palpites de todos no grupo. Para saber mais acesse
            "Auditoria"
          </p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 text-center">
        <div class="service-box mt-5 mx-auto">
          <mat-icon>scoreboard</mat-icon>
          <h1>Pontuação</h1>
          <p>
            Escalável durante a competição. Permite mais chances aos azarados. A cada fase a premiação aumenta e traz
            mais competição
          </p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 text-center">
        <div class="service-box mt-5 mx-auto">
          <mat-icon>blind</mat-icon>
          <h1>Dicas profissionais</h1>
          <p>
            Veja quanto está valendo a aposta de seleções em cada partida para ajudar as pessoas que não assistem a
            todos os jogos ou não conhecem do esporte
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="chamada">
  <span id="compartilhe">Compartilhe com seus amigos</span>
  @if (canShare) {
    <button mat-button mat-raised-button (click)="shareApp()" aria-labelledby="compartilhe">
      <mat-icon>share</mat-icon>
    </button>
  }
</div>
<div #regras>
  <app-rules></app-rules>
</div>
